import { observable, flow } from 'mobx'
import { TodistuksetPriceList } from 'todistukset-common/src/vtj/types/price-list.type'
import { get } from 'common/src/vtj/browser/http'

export type PriceListStore = {
  isLoading: boolean
  data: TodistuksetPriceList | null
  error: Error | null
  refresh: () => void
}

export const priceListStore: PriceListStore = observable({
  isLoading: false,
  data: null,
  error: null,
  refresh: flow(function* () {
    priceListStore.isLoading = true
    priceListStore.error = null
    const [err, response] = yield get('/api/public/price-list')
    priceListStore.isLoading = false
    if (err) {
      priceListStore.error = err
    } else {
      priceListStore.data = response.data
    }
  }),
})
